import { FC, ReactNode } from 'react';

import ErrorIcon from '@mui/icons-material/Error';
import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';

import { useConfirm, UseConfirmProps } from 'lib';

type Props = LoadingButtonProps &
  UseConfirmProps & {
    confirmText?: ReactNode;
    confirmIcon?: ReactNode;
  };

const ConfirmableLoadingButton: FC<Props> = props => {
  const {
    startIcon,
    children,
    enabled,
    onConfirm,
    confirmText = 'Tikrai?',
    confirmIcon = <ErrorIcon fontSize="small" />,
    color,
    ...rest
  } = props;
  const { confirming, ...confirm } = useConfirm({ enabled, onConfirm });

  return (
    <LoadingButton
      {...rest}
      {...confirm}
      color={confirming ? 'error' : color}
      startIcon={confirming ? confirmIcon : startIcon}>
      {confirming ? confirmText : children}
    </LoadingButton>
  );
};

export default ConfirmableLoadingButton;
